import {SET_STORAGE_TIMESTAMP, REMOVE_STORAGE} from "../../actions/actionTypes";

export function storageReducer(state, action) {
    state = (state || {});
    switch (action.type) {
        case SET_STORAGE_TIMESTAMP:
            return Object.assign({}, state, {timestamp: action.timestamp});
        case REMOVE_STORAGE:
            return Object.assign({}, state, {timestamp: undefined});
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/common/storageReducer.js